import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    clipRule="evenodd"
    d="M22 10C22 14.3153 19.2666 17.9922 15.4367 19.3938L15.4228 19.4006C14.5043 19.8506 13.744 20.5688 13.2424 21.4602C13.167 21.5942 13.0978 21.7369 12.9595 22.0221L12.9594 22.0221L12.9594 22.0222L12 24L11.0406 22.0222L11.0406 22.0222L11.0406 22.0221C10.9022 21.7369 10.833 21.5942 10.7576 21.4602C10.256 20.5688 9.49573 19.8506 8.57724 19.4006L8.56328 19.3938C4.73341 17.9922 2 14.3153 2 10C2 4.47715 6.47715 0 12 0C17.5228 0 22 4.47715 22 10ZM12 13.9998C14.2091 13.9998 16 12.2089 16 9.99976C16 7.79062 14.2091 5.99976 12 5.99976C9.79086 5.99976 8 7.79062 8 9.99976C8 12.2089 9.79086 13.9998 12 13.9998Z"
    fillRule="evenodd"/>
  ,
  'POIPin',
)
